import { CTModelDatatableFilter } from "@ctsolution/ct-framework";
import { EventPathParam } from "../../../_core/classes/event-path-param";

/**
 * Configurazione per il componente SchedulerList
 * Gestisce il comportamento della lista eventi e la modalità di apertura dello scheduler
 */
export class SchedulerListConfiguration {

  /** Se true, mostra solo il pulsante di modifica (nasconde creazione) */
  onlyUpdate: boolean = false;

  /** Parametro URL extra da passare allo scheduler */
  extraUrlParam: string | null = null;

  /** Se true, naviga dopo aver eseguito l'Action callback */
  navigatePostAction: boolean = true;

  /** 
   * Se true, apre lo scheduler in una modale invece di navigare alla pagina
   * Questo è il nuovo comportamento che evita il cambio di pagina
   */
  useModal: boolean = false;

  constructor(
    public Filters: Array<CTModelDatatableFilter> | null = null,
    public param: EventPathParam | null = null,
    public Action: ((event: any) => void) | null = null
  ) { }

  /**
   * Imposta il callback da eseguire prima di aprire lo scheduler
   * @param value Funzione callback (es. salvataggio form parent)
   * @returns Istanza corrente per method chaining
   */
  setAction(value: ((event: any) => void) | null = null): SchedulerListConfiguration {
    this.Action = value;
    return this;
  }

  /**
   * Imposta se mostrare solo il pulsante di modifica
   * @param value true per nascondere il pulsante di creazione
   * @returns Istanza corrente per method chaining
   */
  setOnlyUpdate(value: boolean): SchedulerListConfiguration {
    this.onlyUpdate = value;
    return this;
  }

  /**
   * Imposta il parametro URL extra
   * @param value Valore del parametro extra
   * @returns Istanza corrente per method chaining
   */
  setExtraUrlParam(value: string): SchedulerListConfiguration {
    this.extraUrlParam = value;
    return this;
  }

  /**
   * Imposta i parametri dell'entità di origine
   * @param value Parametri EventPathParam (tipo e oid)
   * @returns Istanza corrente per method chaining
   */
  setParam(value: EventPathParam | null): SchedulerListConfiguration {
    this.param = value;
    return this;
  }

  /**
   * Imposta se navigare dopo aver eseguito l'Action
   * @param value true per navigare dopo l'action
   * @returns Istanza corrente per method chaining
   */
  setNavigatePostAction(value: boolean): SchedulerListConfiguration {
    this.navigatePostAction = value;
    return this;
  }

  /**
   * Imposta se usare la modale invece della navigazione
   * Quando true, lo scheduler si apre in una modale al posto di cambiare pagina
   * @param value true per usare la modale
   * @returns Istanza corrente per method chaining
   */
  setUseModal(value: boolean): SchedulerListConfiguration {
    this.useModal = value;
    return this;
  }
}
